import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { clearSignatureState, saveSignaturesPcr } from '../store/signatures.actions'
import { SignaturesConstants } from '../store/signatures.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getSignaturesSelector } from '../selectors/getSignatures.selector'
import { ISignaturesState } from '../store/signatures.types'
import { revokeAllSignatureUrls } from '../../../utilities/signature.util'

export function* deleteAllSignatures() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrId: string = yield select(getPcrIdSelector)
  if (!pcrId) {
    return
  }
  try {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)
    if (pcrDoc._attachments) {
      if (pcrDoc._attachments.StandardSignatures_Section1_Ambulance) {
        delete pcrDoc._attachments.StandardSignatures_Section1_Ambulance
      }
      if (pcrDoc._attachments.StandardSignatures_Section1_Patient) {
        delete pcrDoc._attachments.StandardSignatures_Section1_Patient
      }
      if (pcrDoc._attachments.StandardSignatures_Section1_Witness) {
        delete pcrDoc._attachments.StandardSignatures_Section1_Witness
      }
      if (pcrDoc._attachments.StandardSignatures_Section2_Representative) {
        delete pcrDoc._attachments.StandardSignatures_Section2_Representative
      }
      if (pcrDoc._attachments.StandardSignatures_Section3_Crew) {
        delete pcrDoc._attachments.StandardSignatures_Section3_Crew
      }
      if (pcrDoc._attachments.StandardSignatures_Section3_Receiving) {
        delete pcrDoc._attachments.StandardSignatures_Section3_Receiving
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDoc)
    }
    const signaturesState: ISignaturesState = yield select(getSignaturesSelector)
    revokeAllSignatureUrls(signaturesState)
    yield put(clearSignatureState())
    yield put(saveSignaturesPcr())
  } catch (e) {
    yield put(throwPcrException(e))
  }
}

export function* deleteAllSignaturesSaga() {
  yield takeLatest([SignaturesConstants.DELETE_ALL_SIGNATURE_DATA], performWithMutexHOG, deleteAllSignatures)
}
